import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import cn from "../../../external/classnames/index.js";
import { forwardRef } from "react";
import { ListItemText } from "./ListItemText.js";
import { LIST_ITEM_CLASSNAME, SELECTED_CLASSNAME } from "./constants.js";
import { listItemStyles, listItemSizeStyles } from "./listItemStyles.js";
import { spreadSx } from "../../../utils/spreadSx.js";
const ListItem = forwardRef(
  ({
    children,
    size = "md",
    startAdornment,
    endAdornment,
    onClick,
    onMouseUp,
    disabled,
    selected,
    sx,
    id,
    ...props
  }, ref) => /* @__PURE__ */ jsxs(
    Box,
    {
      ref,
      component: "button",
      className: cn(
        LIST_ITEM_CLASSNAME,
        selected ? SELECTED_CLASSNAME : void 0
      ),
      disabled,
      onClick,
      onMouseUp,
      type: "button",
      id,
      sx: [
        listItemStyles.containerColors,
        listItemSizeStyles.containerSizes[size],
        listItemStyles.containerParameters,
        ...spreadSx(sx)
      ],
      ...props,
      children: [
        startAdornment && /* @__PURE__ */ jsx(
          Box,
          {
            sx: [
              listItemStyles.iconBoxColors,
              listItemSizeStyles.iconBoxSizes[size]
            ],
            children: startAdornment
          }
        ),
        /* @__PURE__ */ jsx(Box, { sx: listItemStyles.content, children: typeof children == "string" ? /* @__PURE__ */ jsx(ListItemText, { size, children }) : children }),
        endAdornment && /* @__PURE__ */ jsx(
          Box,
          {
            sx: [
              listItemStyles.iconBoxColors,
              listItemSizeStyles.iconBoxSizes[size]
            ],
            children: endAdornment
          }
        )
      ]
    }
  )
), ListContainer = ({ size = "md", children, sx }) => /* @__PURE__ */ jsx(
  Box,
  {
    className: cn(LIST_ITEM_CLASSNAME),
    sx: [
      listItemSizeStyles.containerSizes[size],
      listItemStyles.containerParameters,
      ...spreadSx(sx)
    ],
    children: /* @__PURE__ */ jsx(Box, { sx: listItemStyles.content, children })
  }
);
export {
  ListContainer,
  ListItem
};
//# sourceMappingURL=ListItem.js.map
